export const SHIPPING_DELIVERY_LINK =
  "https://support.matchwornshirt.com/hc/en-us/categories/15828065731100-SHIPPING-DELIVERY";

export const HOW_IT_WORKS_LINK = "/how-it-works";

export const MWS_HOMEPAGE_LINK = "/";
